import axios from "axios";
import { domain } from "../Constants";

const collection = {
    getCategory() {
        return axios({
            url: `${domain}api/category`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get category\n', e.message);
            return { status: e.response.status }
        });
    },
    getSubCategoryAll() {
        return axios({
            url: `${domain}api/subcategory`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get sub category\n', e.message);
            return { status: e.response.status }
        });
    },
    getSubCategoryById(id) {
        return axios({
            url: `${domain}api/get-sub-category?id=${id}`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get sub category\n', e.message);
            return { status: e.response.status }
        });
    },


};

export default collection;
